import { IconButton, Icon, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(() => ({}));

const ResponsiveButton = (props) => {
  return props.small ? (
    <IconButton
      variant={props.variant || 'text'}
      color={props.color || 'primary'}
      size={props.size || 'small'}
      onClick={props.onClick}
    >
      <Icon>{props.icon}</Icon>
    </IconButton>
  ) : (
    <Button
      variant={props.variant || 'text'}
      color={props.color || 'primary'}
      size={props.size || 'small'}
      onClick={props.onClick}
      startIcon={<Icon>{props.icon}</Icon>}
    >
      {props.children}
    </Button>
  );
};

export default ResponsiveButton;
